/* =========================================================================
   KENZA · ONLINE ACADEMY
   Mobile carousel — only active when data-mobile-layout="carousel"
   - Arrow buttons scroll to prev/next card
   - Arrows hide at start (prev) and end (next)
   - Dots reflect scroll position; clicking a dot scrolls to that card
   ========================================================================= */

(function () {
  'use strict';

  var MOBILE_BP = '(max-width: 749px)';
  var SCROLL_PAD_LEFT = 20; /* matches CSS padding on the track */

  function initSection(section) {
    var layout = section.getAttribute('data-mobile-layout') || 'carousel';
    if (layout !== 'carousel') return; /* stacked mode = no JS needed */

    var track = section.querySelector('[data-kenza-academy-track]');
    var trackWrap = section.querySelector('.kenza-academy__track-wrap');
    var dots = section.querySelectorAll('[data-kenza-academy-dot]');
    var prevBtn = section.querySelector('[data-kenza-academy-arrow="prev"]');
    var nextBtn = section.querySelector('[data-kenza-academy-arrow="next"]');

    if (!track || !trackWrap) return;

    var cards = track.querySelectorAll('.kenza-academy__card');
    if (cards.length === 0) return;

    var isMobile = function () {
      return window.matchMedia(MOBILE_BP).matches;
    };

    /* ── Find the card index closest to current scroll position ──────── */
    var getCurrentIndex = function () {
      var scrollLeft = trackWrap.scrollLeft;
      var closestIdx = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cardLeft = cards[i].offsetLeft - SCROLL_PAD_LEFT;
        var dist = Math.abs(cardLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      }
      return closestIdx;
    };

    /* ── Scroll to a specific card index ─────────────────────────────── */
    var scrollToIndex = function (idx) {
      if (idx < 0 || idx >= cards.length) return;
      var card = cards[idx];
      trackWrap.scrollTo({
        left: card.offsetLeft - SCROLL_PAD_LEFT,
        behavior: 'smooth'
      });
    };

    /* ── Update active dot + arrow visibility ────────────────────────── */
    var updateUI = function () {
      if (!isMobile()) return;

      var idx = getCurrentIndex();

      /* Dots */
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) {
          dots[i].classList.add('is-active');
        } else {
          dots[i].classList.remove('is-active');
        }
      }

      /* Arrow visibility — hide prev at start, hide next at end.
         Small tolerance because scroll-snap can leave us 1-2px off. */
      var atStart = trackWrap.scrollLeft <= 2;
      var atEnd = trackWrap.scrollLeft + trackWrap.clientWidth >= trackWrap.scrollWidth - 2;

      if (prevBtn) {
        if (atStart) {
          prevBtn.classList.add('is-hidden');
        } else {
          prevBtn.classList.remove('is-hidden');
        }
      }
      if (nextBtn) {
        if (atEnd) {
          nextBtn.classList.add('is-hidden');
        } else {
          nextBtn.classList.remove('is-hidden');
        }
      }
    };

    /* ── Position arrows vertically over the image area ──────────────── */
    var carousel = section.querySelector('[data-kenza-academy-carousel]');
    var positionArrows = function () {
      if (!isMobile()) return;
      if (!prevBtn && !nextBtn) return;
      if (!carousel) return;
      var firstCard = cards[0];
      if (!firstCard) return;
      var media = firstCard.querySelector('.kenza-academy__media');
      if (!media) return;
      var mediaRect = media.getBoundingClientRect();
      var carouselRect = carousel.getBoundingClientRect();
      /* Image vertical center, expressed as pixels from top of carousel wrapper.
         Arrows are children of the carousel and use translateY(-50%), so this top
         coordinate is the desired center line. */
      var arrowTop = (mediaRect.top - carouselRect.top) + (mediaRect.height / 1);
      if (prevBtn) prevBtn.style.top = arrowTop + 'px';
      if (nextBtn) nextBtn.style.top = arrowTop + 'px';
    };

    /* ── ARROWS ──────────────────────────────────────────────────────── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!isMobile()) return;
        var idx = getCurrentIndex();
        scrollToIndex(Math.max(0, idx - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!isMobile()) return;
        var idx = getCurrentIndex();
        scrollToIndex(Math.min(cards.length - 1, idx + 1));
      });
    }

    /* ── DOT CLICKS ──────────────────────────────────────────────────── */
    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        if (!isMobile()) return;
        scrollToIndex(idx);
      });
    });

    /* ── SCROLL → update active state (rAF throttled) ────────────────── */
    var scrollRaf = null;
    trackWrap.addEventListener('scroll', function () {
      if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
      scrollRaf = window.requestAnimationFrame(updateUI);
    }, { passive: true });

    /* ── RESIZE ──────────────────────────────────────────────────────── */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) {
          positionArrows();
          updateUI();
        } else {
          /* Desktop: clear inline arrow top + reset dot to first */
          if (prevBtn) prevBtn.style.top = '';
          if (nextBtn) nextBtn.style.top = '';
          dots.forEach(function (dot, idx) {
            if (idx === 0) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
          if (prevBtn) prevBtn.classList.remove('is-hidden');
          if (nextBtn) nextBtn.classList.remove('is-hidden');
        }
      }, 150);
    }, { passive: true });

    /* ── INITIAL STATE ───────────────────────────────────────────────── */
    /* Run once on init so prev arrow is hidden from the start */
    if (isMobile()) {
      positionArrows();
      updateUI();
    }

    /* Reposition after first image actually loads (sizes are unknown until then) */
    var firstImg = cards[0] ? cards[0].querySelector('img') : null;
    if (firstImg) {
      if (firstImg.complete) {
        positionArrows();
      } else {
        firstImg.addEventListener('load', positionArrows, { once: true });
      }
    }

    /* Window load fallback (covers placeholder cases too) */
    window.addEventListener('load', function () {
      if (isMobile()) positionArrows();
    }, { once: true });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-kenza-academy]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify section editor support */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-kenza-academy]');
    if (section) initSection(section);
  });
})();